import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleMerchandiseMetadata: (field: string, value: string) => void;
};

export default function ColorFormGroup({
  album,
  readonly,
  disabled,
  handleMerchandiseMetadata,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.color')}
        handleInput={(e) => {
          handleMerchandiseMetadata('color', e.target.value);
        }}
        id="color"
        type="text"
        value={album.merchandiseMetadata?.color ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
      />
    </div>
  );
}
